<script setup lang="ts">
    const route = useRoute();
    const url = `/about${route.hash}`;
</script>
<template>
    <div>
        <!-- See pages/about/index.vue: framed content, so a hidden page heading. -->
        <h1 class="sr-only">About the Chicago Architecture Center</h1>
        <UtilitiesWebView :url="url" />
    </div>
</template>
